type TestimonialBase = {
  name: string;
  role: string;
  description: string;
};

export type GalleryPhoto = {
  src: string;
  alt: string;
};

export type TestimonialGallery = TestimonialBase & {
  layout: 'gallery';
  photos: [GalleryPhoto, GalleryPhoto, GalleryPhoto];
};

export type TestimonialBeforeAfter = TestimonialBase & {
  layout: 'beforeAfter';
  beforeAfter: {
    before: { src: string; alt: string };
    after: { src: string; alt: string };
  };
};

export type Testimonial = TestimonialGallery | TestimonialBeforeAfter;

export const TestimonialsCatalog: Testimonial[] = [
  {
    name: 'Sarah M.',
    role: 'Home client',
    description:
      "I've never seen my home sparkle like this before. The team was friendly, on time, and incredibly thorough.",
    layout: 'gallery',
    photos: [
      {
        src: '/images/testimonials/web/testimonial_1/photo_1.jpg',
        alt: 'Freshly cleaned dining area',
      },
      { src: '/images/testimonials/web/testimonial_1/photo_2.jpg', alt: 'Tidied living space' },
      {
        src: '/images/testimonials/web/testimonial_1/photo_3.jpg',
        alt: 'Spotless bedroom after cleaning',
      },
    ],
  },
  {
    name: 'Daniel R.',
    role: 'Home client',
    description:
      "They went above and beyond. Every corner is spotless, and they took care of details I wouldn't have thought of myself.",
    layout: 'gallery',
    photos: [
      {
        src: '/images/testimonials/web/testimonial_2/photo_1.jpg',
        alt: 'Spotless kitchen surfaces',
      },
      { src: '/images/testimonials/web/testimonial_2/photo_2.jpg', alt: 'Clean bathroom fixtures' },
      { src: '/images/testimonials/web/testimonial_2/photo_3.jpg', alt: 'Freshly cleaned hallway' },
    ],
  },
  {
    name: 'Emily K.',
    role: 'Move-out clean',
    description:
      'Professional, efficient, and affordable. I was amazed at how quickly they transformed my living space.',
    layout: 'beforeAfter',
    beforeAfter: {
      before: {
        src: '/images/testimonials/web/testimonial_3/before.jpg',
        alt: 'Kitchen sink before cleaning',
      },
      after: {
        src: '/images/testimonials/web/testimonial_3/after.jpg',
        alt: 'Kitchen sink after cleaning',
      },
    },
  },
  {
    name: 'Michael T.',
    role: 'Office client',
    description:
      "The best cleaning service I've hired. Courteous, respectful of my home, and everything looked fantastic.",
    layout: 'beforeAfter',
    beforeAfter: {
      before: {
        src: '/images/testimonials/web/testimonial_4/before.jpg',
        alt: 'Office counter before cleaning',
      },
      after: {
        src: '/images/testimonials/web/testimonial_4/after.jpg',
        alt: 'Office counter after cleaning',
      },
    },
  },
];
